import { z } from "zod";
import { type FunctionObjectReturn } from "../utils";

const OptionalStringArraySchema = z.preprocess((value: unknown) => value ?? undefined, z.array(z.string())).optional();

export const CreateCheckoutSchema = z.object({
  priceId: z.string(),
  promotionCode: z.string().nullish(),
  origin: z.string(),
  toltReferralPartnerId: z.string().nullish(), // Comes from Tolt Click Tracking
  audioCourseRecommendationIds: OptionalStringArraySchema,
  meditationRecommendationIds: OptionalStringArraySchema,
});

// Use z.infer to create a type that matches the Zod schema
export type CreateCheckoutPostBody = z.infer<typeof CreateCheckoutSchema>;

export interface CreateCheckout {
  redirectUrl: string;
}

export type CreateCheckoutResponse = FunctionObjectReturn<CreateCheckout>;
